import { fontWeightClassName, fontWeights } from '@va/ui/design-system';
import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import { getTypographyClassNames } from './helpers';
import { HeadingProps, TypographyProps, TypographyVariants } from './types';

export const Heading4 = <T extends keyof TypographyVariants>({
  weight = fontWeights.normal,
  colorClassName = 'text-text-dark',
  variant,
  variantSize,
  className,
  children,
}: PropsWithChildren<HeadingProps & TypographyProps<T>>) => {
  const typographyClasses = getTypographyClassNames({ variant, variantSize });

  const classes = classNames(
    'font-primary',
    { 'text-2xl leading-33 -tracking-0021': !typographyClasses, [typographyClasses]: !!typographyClasses },
    fontWeightClassName(weight),
    colorClassName,
    className,
  );

  return <h4 className={classes}>{children}</h4>;
};
